import type { Destination, ESN } from '@cobliteam/common-types';

import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import type { Configuration } from '../../request/Types';

export class VehiclesRequester {
  private requester: Requester;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
  }

  public getBrands = (): Promise<string[]> => {
    const requestData = {
      endpoint: '/dash/vehicle/brands',
      method: HttpMethod.GET,
    };

    return this.requester.request(requestData).then((response) => response.data.brands);
  };

  public getModels = (brand: string): Promise<string[]> => {
    const encodedBrand = encodeURIComponent(brand);
    const requestData = {
      endpoint: `/dash/vehicle/brands/${encodedBrand}/models`,
      method: HttpMethod.GET,
    };

    return this.requester.request(requestData).then((response) => response.data.models);
  };

  public getYears = (brand: string, model: string): Promise<string[]> => {
    const encodedBrand = encodeURIComponent(brand);
    const encodedModel = encodeURIComponent(model);
    const requestData = {
      endpoint: `/dash/vehicle/brands/${encodedBrand}/models/${encodedModel}/years`,
      method: HttpMethod.GET,
    };

    return this.requester.request(requestData).then((response) => response.data.years);
  };

  public createEtaPage = (deviceId: ESN, destination: Destination, isTracking?: boolean) => {
    const requestData = {
      endpoint: '/dash/vehicle/eta',
      method: HttpMethod.POST,
      body: JSON.stringify({
        device_id: deviceId,
        destination: {
          lat: destination.lat,
          lng: destination.lng,
          address: destination.address,
        },
        is_tracking: isTracking,
      }),
    };

    return this.requester.request(requestData).then((response) => response.data.url);
  };
}

export default VehiclesRequester;
